import React, { useState } from 'react';

interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}

const FAQItem: React.FC<FAQItemProps> = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="mb-4">
      <button 
        className="w-full text-left p-6 rounded-lg bg-dark-lighter flex justify-between items-center"
        onClick={onClick}
      >
        <span className="text-white text-lg font-medium">{question}</span>
        <span className="text-white ml-4">
          {isOpen ? (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
            </svg>
          ) : (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
          )}
        </span>
      </button>
      
      {isOpen && (
        <div className="p-6 pt-2 text-gray-400">
          {answer}
        </div>
      )}
    </div>
  );
};

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  
  const toggleFAQ = (index: number) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };
  
  const faqs = [
    {
      question: "How does ValetPe process refunds so quickly?",
      answer: "ValetPe uses advanced AI algorithms to validate refund requests instantly, eliminating the traditional waiting period. We front the refund amount to you immediately while we handle the processing with the merchant behind the scenes."
    },
    {
      question: "Is there a limit to how many refunds I can request?",
      answer: "No, there is no fixed limit on the number of legitimate refund requests. We use smart algorithms to prevent abuse while ensuring genuine customers can always get their money back without hassle."
    },
    {
      question: "Are all my purchases protected with ValetPe?",
      answer: "Yes, all purchases made through ValetPe-partnered merchants are eligible for our instant refund guarantee. For non-partner merchants, you still receive our standard refund protection services."
    },
    {
      question: "Do I need to sign up for an account to use ValetPe?",
      answer: "Yes, you'll need to create a free ValetPe account to access our services. The sign-up process is quick and straightforward, requiring just your basic information and verification."
    },
    {
      question: "How do I know which merchants are part of the ValetPe network?",
      answer: "All ValetPe partner merchants display our logo at checkout. You can also find a complete list of our partner brands in the ValetPe app or on our website under the 'Partner Brands' section."
    }
  ];

  return (
    <section className="bg-dark py-20 px-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-300 mb-16">
          Your Questions, Our Answers
        </h2>
        
        {faqs.map((faq, index) => (
          <FAQItem 
            key={index}
            question={faq.question}
            answer={faq.answer}
            isOpen={openIndex === index}
            onClick={() => toggleFAQ(index)}
          />
        ))}
      </div>
    </section>
  );
};

export default FAQ;